import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { getDashboardRoute } from '@modules/dashboard/helpers';
import { useFetchDashboard } from '@modules/dashboard/hooks/useFetchDashboard/useFetchDashboard';
import { DashboardViewFragment } from 'generated/graphql';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';

export const useGetDashboardFromURL = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { showErrorNotification } = useNotificationContext();
  const { token, savedSlug: dashboardSlug } = useParseSavedSlugInfo();

  const onLoadDashboard = (dashboard: DashboardViewFragment) => {
    if (!dashboard || dashboard.viewToken !== token) {
      return;
    }
    // if we don't have exact dashboard link (with name slug), reroute
    const dashboardRoute = getDashboardRoute(dashboard);
    if (
      location.pathname !== dashboardRoute &&
      !location.pathname.includes('/report/')
    ) {
      navigate(dashboardRoute, { replace: true, state: location });
    }
  };

  useEffect(() => {
    // if we have dashboard slug and failed to parse id or token
    if (Boolean(dashboardSlug && !token)) {
      navigate('/');
      showErrorNotification({
        contentComponent: 'Invalid Dashboard Link',
        props: {},
      });
    }
  }, [dashboardSlug, token, navigate, showErrorNotification]);

  return useFetchDashboard({
    token,
    onLoadDashboard,
    skip: !token || !dashboardSlug,
    nextFetchPolicy: 'cache-and-network',
  });
};
